// extracted by mini-css-extract-plugin
export default {"root":"Page_root__cFSIj","unifiedSearchHeader":"Page_unifiedSearchHeader__dZcNR","content":"Page_content__AW2GK","scrollingDisabled":"Page_scrollingDisabled__9bMgr"};